/**
 * 为行增加可扩展的属性，例如物品清单的可间性、
 * 能耗详情的可见性，物品清单列表、能耗详情列表。
 * @param {any} row
 */
export function extendHouseRow(row, i) {
  row.__visible = {
    energyForm: false, // 能耗情况
    manifest: false, // 物品清单
  }

  row.articlesLists = []
  row.energyConsumption = [
    {
      meterReadType: 'WATERMETER',
      houseNumber: '',
      meterReadNumber: '',
    },
    {
      meterReadType: 'ELECTRICMETER',
      houseNumber: '',
      meterReadNumber: '',
    },
    {
      meterReadType: 'GASMETERREAD',
      houseNumber: '',
      meterReadNumber: '',
    },
  ]

  return row
}

/**
 * 表格是否正在编辑
 * @param {any[]} table
 */
export function isTableEditing(table) {
  return table.some(row => {
    return row.__visible['energyForm'] || row.__visible['manifest']
  })
}



// WEBPACK FOOTER //
// ./src/components/forms/BusinessContractForm/utils.js